var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12970",
    "data-name": "Group 12970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12967",
    "data-name": "Path 12967",
    d: "M19.055,9.691H5.985a.448.448,0,0,0-.465.429v.863c0,.04.047.085.085.1l6.87,3.62a.126.126,0,0,0,.117,0l6.663-3.616c.037-.019.137-.07.174-.094s.092-.054.092-.1v-.772A.448.448,0,0,0,19.055,9.691Z",
    transform: "translate(-5.52 -9.691)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12968",
    "data-name": "Path 12968",
    d: "M35.857,17.084a.126.126,0,0,0-.117,0l-3.77,2.046a.107.107,0,0,0-.056.077.1.1,0,0,0,.03.088l3.771,3.75a.12.12,0,0,0,.085.034.112.112,0,0,0,.116-.107v-5.8A.106.106,0,0,0,35.857,17.084Z",
    transform: "translate(-21.915 -14.491)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12969",
    "data-name": "Path 12969",
    d: "M14.776,24.871a.123.123,0,0,0-.144-.02l-1.511.82a.633.633,0,0,1-.583,0l-1.33-.7a.124.124,0,0,0-.137.014L6.02,29.31a.1.1,0,0,0-.036.09.107.107,0,0,0,.057.081.478.478,0,0,0,.231.063H19.209a.116.116,0,0,0,.106-.065.1.1,0,0,0-.021-.116Z",
    transform: "translate(-5.808 -19.544)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12970",
    "data-name": "Path 12970",
    d: "M9.672,19.581a.1.1,0,0,0,.037-.091.107.107,0,0,0-.057-.081L5.693,17.324a.124.124,0,0,0-.116,0,.106.106,0,0,0-.058.093v5.471a.107.107,0,0,0,.07.1.123.123,0,0,0,.126-.02Z",
    transform: "translate(-5.52 -14.648)",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.94e0df170730bc48c042afc0aa53d7ce.svg";
export { ForwardRef as ReactComponent };